import { Component, Inject, OnDestroy } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { MxDatasource } from 'src/app/shared/domains/common/interfaces';

import { MxBreadcrumbService, MxIdentityService } from '../../services';
import { MainComponent } from './main.component';

@Component({ standalone: false,
  selector: 'mx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnDestroy {
  subscription: Subscription;

  items: MenuItem[];

  home: MenuItem;

  search: string;

  selectedAppSubscription: number;
  appSubscriptions: MxDatasource[];

  constructor(
    public breadcrumbService: MxBreadcrumbService,
    public main: MainComponent,
    private identityService: MxIdentityService
  ) {
    this.subscription = breadcrumbService.itemsHandler.subscribe((response) => {
      this.items = response;
    });
  }

  ngOnInit() {
    this.appSubscriptions = [];
    this.appSubscriptions.push({
      label: this.identityService.accountValue.subscription.name,
      value: this.identityService.accountValue.subscription.id,
    });

    this.selectedAppSubscription =
      this.identityService.accountValue.subscription.id;
  }

  changeAppSubscription() {
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
